import React from 'react'
import css from './PremiumBadge.module.css'


export default function PremiumBadge(props) {
  return  (<div className={css.base}>
     Preferred
  </div>)
}
